import {
  LOAD_USER_PROFILE,
  SET_USER_PROFILE,
  RESET_PROFILE_STATE,
  UPDATING_USER_PROFILE,
  SET_IDP_PROFILE,
  SET_EXISTING_IDP_PROFILE,
  UPDATING_IPD_SETTING
} from '@/state/mutationTypes'
import getProfileStoreDefaultState from './profileStoreDefaultState'

export default {
  [LOAD_USER_PROFILE](state, payload) {
    state.loadUserProfile = payload
  },
  [SET_USER_PROFILE](state, user) {
    state.user = user
  },
  [UPDATING_USER_PROFILE](state, payload) {
    state.updatigUserProfile = payload
  },
  [SET_IDP_PROFILE](state, payload) {
    state.IDPProfile = payload
  },
  [SET_EXISTING_IDP_PROFILE](state, payload) {
    state.existingIDPProfile = payload
  },
  [UPDATING_IPD_SETTING](state, payload) {
    state.updatingIDPSettings = payload
  },
  [RESET_PROFILE_STATE](state) {
    Object.assign(state, getProfileStoreDefaultState())
  }
}
